import { DialogService, GridButton } from '@eforall/dashboard';
import { DialogMode } from '@interfaces';
import { AccApplicationDialogDataService } from '../../../../acc-application-dialog/acc-application-dialog-data.service';
import { EngagementEditorDialog, EngagementEditorDialogData } from '../../../../dialog/engagement-editor/engagement-editor.dialog';
import { PersonDialogDataService } from '../../../person-dialog-data.service';


export function getButtons(personDialogDataService: PersonDialogDataService, accApplDialogDataService: AccApplicationDialogDataService, dialogService: DialogService) {

	const buttons: GridButton[] = [
		{
			iconClass: 'fa-plus',
			label: 'Add engagement request',
			execute: async () => {
				const dialogData: EngagementEditorDialogData = {
					mode: DialogMode.ADD,
					personId: personDialogDataService.personDetails()?.personId
				};
				const dialogAction = await dialogService.showCustom(EngagementEditorDialog, { data: dialogData }, 650, 800);

				// If save succeeds, callbackResult contains the created engagementId; otherwise, it is undefined.
				if (dialogAction?.callbackResult) {
					const personId = personDialogDataService.personDetails()?.personId;
					if (personId) {
						await personDialogDataService.getAllEngagementsByPerson(personId);
					}

					await accApplDialogDataService.reloadData();
				}
			}
		},
		{
			iconClass: 'fa-refresh',
			label: 'Refresh',
			execute: async () => {
				const personId = personDialogDataService.personDetails()?.personId;
				if (personId) {
					await personDialogDataService.getPersonDetails(personId, false);
					await personDialogDataService.getAllEngagementsByPerson(personId);
				}
				await accApplDialogDataService.reloadData();
			}
		},
	];

	return buttons;
}